import { Component, inject } from '@angular/core';
import { AlertService } from '../../services/alert/alert.service';
import { ModalData, ModalService } from './modal.service';
import { ErrorHandler } from '../../utils/error';

@Component({
	selector: 'ipb-modal',
	templateUrl: './modal.component.html',
})
export class ModalComponent {
	#alertService = inject(AlertService);
	constructor(private readonly modalService: ModalService) {}

	get config(): ModalData {
		return this.modalService.config;
	}

	onCancel() {
		this.modalService.onCancel();
	}

	async onConfirmAsync() {
		try {
			this.modalService.onLoading();
			await this.modalService.onConfirmAsync();
			this.modalService.onLoaded();
		} catch (error) {
			this.#alertService.error('An error occurred. Please try again later.', 'modal-error');
			ErrorHandler.handleError(error);
		} finally {
			this.modalService.onLoaded();
		}
	}

	close(): void {
		this.modalService.close();
	}
}
